import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M2 2l20 20" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 10v2a7 7 0 0 0 12 5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 19v3" })
	]
});
const ForwardRef = forwardRef(SvgMicOff);
export default ForwardRef;
